import React from 'react';

const IndexTags = ({
  data,
  seperator = ', ',
  onTagClick,
  map = { key: 'id', value: 'name' },
  href,
  className,
}) => {
  /**
   * Map through array of ids (data)
   * @return {array} Array whose elements are either <tags> or [<tag>, <seperator>]
   */
  const tagsAndSeperatorsArray = data.map((tag, i) => {
    const tagComponent = (
      <a
        onClick={e => {
          e.preventDefault();
          onTagClick(tag[map.key]);
        }}
        key={tag.id}
        href={href.replace('{{key}}', tag[map.key])}
        className="IndexTable-tag target"
        children={tag[map.value]}
      />
    );

    // eslint-disable-next-line react/no-array-index-key
    const seperatorComponent = <span key={`sep.${i}`}>{seperator}</span>;

    return i < data.length - 1
      ? [tagComponent, seperatorComponent]
      : tagComponent;
  });

  /* Flatting tagsAndSeperatorsArray */
  const tags = [...tagsAndSeperatorsArray];

  return <span className={className}>{tags}</span>;
};

export default IndexTags;
